<div *ngIf="initialized" class="w3-container w3-margin-top" [class]="router.back ? 'w3-animate-left' : 'w3-animate-right'">
  <omnipas-pageheader></omnipas-pageheader>
  <div *ngIf="!message.success && !message.error" class="w3-margin">
    <p>{{ 'block.sure' | translate: router.transparams }}</p>
    <input
      type        = "button"
      class       = "w3-button w3-border w3-button-theme w3-mobile w3-margin-right pageButton w3-round"
      name        = "submit"
      value       = "{{ 'buttons.yes' | translate: router.transparams }}"
      title       = "{{ 'buttons.yes' | translate: router.transparams }}"
      (click)     = "blockcard()"
    >
    <input
      type        = "button"
      class       = "w3-button w3-border w3-button-theme w3-mobile pageButton w3-round"
      name        = "cancel"
      value       = "{{ 'buttons.no' | translate: router.transparams }}"
      title       = "{{ 'buttons.no' | translate: router.transparams }}"
      (click)     = "cancel()"
    >
  </div>
  <div *ngIf="message.success && showRequestNew && !showLogout" class="w3-margin">
    <p>{{ 'block.requestnew' | translate: router.transparams }}</p>
    <input
      type        = "button"
      class       = "w3-button w3-border w3-button-theme w3-mobile w3-margin-right pageButton w3-round"
      name        = "submit"
      value       = "{{ 'buttons.yes' | translate: router.transparams }}"
      title       = "{{ 'buttons.yes' | translate: router.transparams }}"
      (click)     = "requestnew()"
    >
    <input
      type        = "button"
      class       = "w3-button w3-border w3-button-theme w3-mobile pageButton w3-round"
      name        = "cancel"
      value       = "{{ 'buttons.no' | translate: router.transparams }}"
      title       = "{{ 'buttons.no' | translate: router.transparams }}"
      (click)     = "setLogout()"
    >
  </div>
  <div *ngIf="( message.error || message.success ) && environment.getEnvValue('logoutbutton')" class="w3-margin">
    <p>{{ 'block.logout' | translate: router.transparams }}</p>
    <input
      type        = "button"
      class       = "w3-button w3-border w3-button-theme w3-mobile pageButton w3-round"
      name        = "logout"
      value       = "{{ 'buttons.logout' | translate: router.transparams }}"
      title       = "{{ 'buttons.logout' | translate: router.transparams }}"
      (click)     = "logout()"
    >
  </div>
</div>
